var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3243 0H1.25179C0.561147 0 0 0.568996 0 1.26749V16.3125C0 17.011 0.561147 17.58 1.25179 17.58H16.3243C17.0149 17.58 17.58 17.011 17.58 16.3125V1.26749C17.58 0.568996 17.0149 0 16.3243 0ZM5.31324 15.0686H2.70763V6.67883H5.31717V15.0686H5.31324ZM4.01044 5.53299C3.1746 5.53299 2.49966 4.85412 2.49966 4.02221C2.49966 3.1903 3.1746 2.51143 4.01044 2.51143C4.84235 2.51143 5.52122 3.1903 5.52122 4.02221C5.52122 4.85805 4.84627 5.53299 4.01044 5.53299ZM15.0803 15.0686H12.4747V10.9875C12.4747 10.0143 12.4551 8.76253 11.1209 8.76253C9.76318 8.76253 9.5552 9.82204 9.5552 10.9169V15.0686H6.94959V6.67883H9.44925V7.82467H9.48457C9.83381 7.16542 10.6853 6.47085 11.9528 6.47085C14.5898 6.47085 15.0803 8.20923 15.0803 10.4695V15.0686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkm);
export default __webpack_public_path__ + "static/media/linkm.bcd679ed0b18e67038a61978505ec76d.svg";
export { ForwardRef as ReactComponent };